import { useContext } from "react";
import DataContext from "./dataContext";

const useData = () => {
    return useContext(DataContext);
};

export default useData;
